import React, { memo, useMemo } from "react";
import cls from "classnames";

import Iconfont from "~/components/ui/Iconfont";

import styles from "./styles.scss";

type Props = {
  className?: string;
  value: string;
};

const Stars: React.FC<Props> = (props) => {
  const [int, float] = (props.value || "").split(".");
  const starsArr = useMemo(() => {
    const baseArr = new Array(5).fill(0);
    baseArr.splice(0, Number(int), ...new Array(Number(int)).fill(1));
    Number(float) > 0 && baseArr.splice(Number(int), 1, Number(float) > 0 ? Number(float) * 10 : 0);
    return baseArr;
  }, [int, float]);
  if (!int && !float) return null;
  return (
    <span className={cls(styles.wrapper, props.className)}>
      {starsArr.map((_, i) =>
        _ > 1 ? (
          <Iconfont
            key={i}
            className={cls(styles.star, styles.percent_star)}
            style={{
              backgroundImage: `linear-gradient(to right, #ffbc49, #ffbc49 ${_}%, transparent ${_}%)`,
            }}
            name="score_yellow"
          />
        ) : (
          <Iconfont
            key={i}
            className={cls(styles.star, _ ? styles.active_star : styles.normal_star)}
            name="score_yellow"
          />
        )
      )}
    </span>
  );
};

export default memo(Stars);
